import { render, staticRenderFns } from "./OutliersRule.vue?vue&type=template&id=07ed506e&"
import script from "./OutliersRule.vue?vue&type=script&lang=ts&"
export * from "./OutliersRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports